export class PipelineEvent {
  name = null
  pendingDescription = null
  complete_description = null
  complete = false

  constructor(name, pendingDescription, completeDescription) {
    this.name = name
    this.pending_description = pendingDescription
    this.complete_description = completeDescription
  }

  markAsComplete() {
    this.complete = true
  }
}
